module.exports = __webpack_public_path__ + "static/media/transactionsHeader.5dca0eee.svg";